(function () {
  const HOOK_URL = "https://hooks.zapier.com/hooks/catch/3563261/4d5h3vu/";
  const MAKES = [
    { id: "mk_acura", name: "Acura" },
    { id: "mk_audi", name: "Audi" },
    { id: "mk_bmw", name: "BMW" },
    { id: "mk_cadillac", name: "Cadillac" },
    { id: "mk_chevrolet", name: "Chevrolet" },
    { id: "mk_dodge", name: "Dodge" },
    { id: "mk_ford", name: "Ford" },
    { id: "mk_lexus", name: "Lexus" },
    { id: "mk_gmc", name: "GMC" },
    { id: "mk_jeep", name: "Jeep" },
    { id: "mk_honda", name: "Honda" },
    { id: "mk_lincoln", name: "Lincoln" },
    { id: "mk_mazda", name: "Mazda" },
    { id: "mk_mercedes-benz", name: "Mercedes-Benz" },
    { id: "mk_nissan", name: "Nissan" },
    { id: "mk_porsche", name: "Porsche" },
    { id: "mk_ram", name: "Ram" },
    { id: "mk_scion", name: "Scion" },
    { id: "mk_subaru", name: "Subaru" },
    { id: "mk_toyota", name: "Toyota" },
    { id: "mk_volkswagen", name: "Volkswagen" }
  ];

  const container = document.querySelector(".popup-get-on-the-list");
  if (!container) return;

  const form = container.querySelector("#popup-get-on-the-list");
  const makeSelect = container.querySelector("#gotl-make");
  const modelSelect = container.querySelector("#gotl-model");
  const yearSelect = container.querySelector("#gotl-year");
  const afterSent = container.querySelector(".after-sent");
  const submitBtn = form.querySelector('[type="submit"]');
  const variantLabel = container.querySelector("[data-gotl-variant-label]");
  let ymmReady = false;

  function makeRequest(url) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: url,
        dataType: "jsonp",
        success: resolve,
        error: function () {
          reject("Ajax error");
        }
      });
    });
  }

  function buildListValues(data, select) {
    const wrap = document.createElement("ul");
    wrap.innerHTML = data.html;
    Array.from(wrap.querySelectorAll("option")).forEach(function (option) {
      select.appendChild(option);
    });
  }

  function fillMakes() {
    if (!makeSelect || ymmReady) return;
    MAKES.forEach(function (item) {
      const option = document.createElement("option");
      option.value = item.id;
      option.innerText = item.name;
      makeSelect.appendChild(option);
    });
    makeSelect.disabled = false;
    ymmReady = true;
  }

  async function onMakeChange() {
    const pleaseSelect = makeSelect.querySelector("#please-select");
    if (pleaseSelect) pleaseSelect.disabled = true;
    modelSelect.textContent = "";
    yearSelect.textContent = "";
    const url =
      "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery111003058814613446805_1746117865070&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_2&prev_val=" +
      makeSelect.value +
      "&current_val=" +
      makeSelect.value +
      "&lang_code=en&pri_lang_code=&_=1746117865079";
    const data = await makeRequest(url);
    buildListValues(data, modelSelect);
    modelSelect.disabled = false;
    yearSelect.disabled = true;
    if (!isPlaceholder(selectedLabel(modelSelect)) && modelSelect.value) {
      await onModelChange();
    }
  }

  async function onModelChange() {
    if (!modelSelect.value || isPlaceholder(selectedLabel(modelSelect))) {
      yearSelect.textContent = "";
      yearSelect.disabled = true;
      return;
    }
    yearSelect.textContent = "";
    const url =
      "https://www.ymmshopify.capacitywebservices.com/ajax/get_dropdowns_version3.php?callback=jQuery1110023537087433045767_1746130184965&domain=awe-tuning.myshopify.com&load=all&data_filter=updated&action=onchange&use_cart_info_ftr=no&version=updated&ver_no=3&current_field=field_3&prev_val=" +
      makeSelect.value +
      "%2C" +
      modelSelect.value +
      "&current_val=" +
      modelSelect.value;
    const data = await makeRequest(url);
    buildListValues(data, yearSelect);
    yearSelect.disabled = false;
  }

  function lockBody() {
    document.body.style.overflow = "hidden";
  }

  function unlockBody() {
    document.body.style.removeProperty("overflow");
  }

  function closePopup() {
    container.classList.remove("show");
    unlockBody();
  }

  function openPopup(button) {
    form.querySelector('[name="contact[sku]"]').value = button.dataset.variantSku || "";
    form.querySelector('[name="contact[variant-title]"]').value = button.dataset.variantTitle || "";
    form.querySelector('[name="contact[variant-id]"]').value = button.dataset.variantId || "";
    if (variantLabel) {
      variantLabel.textContent = button.dataset.variantTitle || "";
    }
    afterSent.style.display = "none";
    submitBtn.style.display = "";
    submitBtn.disabled = false;
    fillMakes();
    container.classList.add("show");
    lockBody();
  }

  function selectedLabel(select) {
    if (!select || !select.selectedOptions || !select.selectedOptions[0]) return "";
    return select.selectedOptions[0].innerText;
  }

  function isPlaceholder(value) {
    return !value || value === "Please Select" || value === "-1";
  }

  async function onSubmit(event) {
    event.preventDefault();
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    if (makeSelect && isPlaceholder(selectedLabel(makeSelect))) {
      makeSelect.setCustomValidity("Please select a make");
      makeSelect.reportValidity();
      makeSelect.setCustomValidity("");
      return;
    }
    if (modelSelect && isPlaceholder(selectedLabel(modelSelect))) {
      modelSelect.setCustomValidity("Please select a model");
      modelSelect.reportValidity();
      modelSelect.setCustomValidity("");
      return;
    }
    if (yearSelect && isPlaceholder(selectedLabel(yearSelect))) {
      yearSelect.setCustomValidity("Please select a year");
      yearSelect.reportValidity();
      yearSelect.setCustomValidity("");
      return;
    }

    submitBtn.disabled = true;
    const formdata = new FormData();
    Array.from(form.elements).forEach(function (field) {
      if (!field.name) return;
      if (field.type === "checkbox") {
        if (field.checked) formdata.append(field.name, field.value || "true");
        return;
      }
      if (field.selectedOptions) {
        const label = selectedLabel(field);
        if (isPlaceholder(label)) return;
        formdata.append(field.name, label);
        return;
      }
      formdata.append(field.name, field.value);
    });

    try {
      const response = await fetch(HOOK_URL, {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const result = await response.json();
      
      if (result && result.status === "success") {
        afterSent.style.display = "block";
        submitBtn.style.display = "none";
        const nameInput = form.querySelector('[name="contact[name]"]');
        const emailInput = form.querySelector('[name="contact[email]"]');
        const privacyInput = form.querySelector('[name="contact[privacy-policy]"]');
        if (nameInput) nameInput.value = "";
        if (emailInput) emailInput.value = "";
        if (privacyInput) privacyInput.checked = false;
        setTimeout(closePopup, 6000);
        
      } else {
        submitBtn.disabled = false;
      }
    } catch (err) {
      submitBtn.disabled = false;
    }
  }

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest(".js-get-on-the-list");
    if (trigger) {
      event.preventDefault();
      openPopup(trigger);
    }
  });

  container.querySelectorAll(".vehicle-popup-close, .wrapper-close").forEach(function (el) {
    el.addEventListener("click", closePopup);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && container.classList.contains("show")) {
      closePopup();
    }
  });

  if (makeSelect) makeSelect.addEventListener("change", onMakeChange);
  if (modelSelect) modelSelect.addEventListener("change", onModelChange);
  form.addEventListener("submit", onSubmit);
})();
